import React, { useState } from 'react';
import DeliverySlotSelect, { parseSlotValue, formatFee } from './DeliverySlotSelect';

const labelStyle = { display: 'block', marginBottom: '8px', color: '#333', fontWeight: 'bold' };

// slots: [{ date, time, fee }]
const AddDeliveryModal = ({ slots, onConfirm, onCancel }) => {
    const [selected, setSelected] = useState('');
    const options = slots.map(s => ({ ...s, suffix: s.fee > 0 ? ` (${formatFee(s.fee)})` : '' }));

    return (
        <div
            onClick={onCancel}
            style={{
                position: 'fixed', inset: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
            }}
        >
            <div
                onClick={(e) => e.stopPropagation()}
                style={{
                    backgroundColor: '#fff', borderRadius: '8px', padding: '24px',
                    maxWidth: '480px', width: '90%', maxHeight: '80vh', overflowY: 'auto'
                }}
            >
                <h3 style={{ marginTop: 0, color: '#333' }}>Add another delivery date</h3>
                {options.length === 0 ? (
                    <p style={{ color: '#666', marginBottom: '20px' }}>No other delivery dates are available right now.</p>
                ) : (
                    <div style={{ marginBottom: '20px' }}>
                        <label htmlFor="add-delivery-slot" style={labelStyle}>Delivery date & time</label>
                        <DeliverySlotSelect
                            id="add-delivery-slot"
                            slots={options}
                            value={selected}
                            onChange={setSelected}
                            placeholder="Select a delivery"
                        />
                    </div>
                )}
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                    <button
                        onClick={onCancel}
                        style={{
                            padding: '10px 20px', border: '1px solid #6c757d', borderRadius: '4px',
                            backgroundColor: '#fff', color: '#6c757d', cursor: 'pointer', fontSize: '14px'
                        }}
                    >
                        Cancel
                    </button>
                    {options.length > 0 && (
                        <button
                            onClick={() => { const { date, time } = parseSlotValue(selected); onConfirm(date, time); }}
                            disabled={!selected}
                            style={{
                                padding: '10px 20px', border: 'none', borderRadius: '4px',
                                backgroundColor: selected ? '#ffb13c' : '#ccc',
                                color: '#fff', fontSize: '14px',
                                cursor: selected ? 'pointer' : 'not-allowed'
                            }}
                        >
                            Add Delivery
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AddDeliveryModal;
